import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {QuestionType} from '../../data/models/questionType';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionTypeService {

  private questionTypesSubject = new BehaviorSubject<QuestionType[]>([]);

  private questionCategoriesSubject = new BehaviorSubject<Map<string, string>>(new Map<string, string>());

  constructor(
    private http: HttpClient,
  ) {
  }

  get questionTypes$(): Observable<QuestionType[]> {
    if (this.questionTypesSubject.getValue().length === 0) {
      this.fetchQuestionTypes()
        .then(questionTypes => this.questionTypesSubject.next(questionTypes));
    }
    return this.questionTypesSubject.asObservable();
  }

  fetchQuestionTypes(): Promise<QuestionType[]> {
    return this.http.get<QuestionType[]>('api/questions-types')
      .toPromise()
      .catch(error => {
        this.questionTypesSubject.next([]);
        return [];
      });
  }

  get questionCategories$(): Observable<Map<string, string>> {
      if (this.questionCategoriesSubject.getValue().size === 0) {
          this.fetchQuestionCategories()
              .then(questionCategories => this.questionCategoriesSubject.next(questionCategories));
      }

    return this.questionCategoriesSubject.asObservable();
  }

  fetchQuestionCategories(): Promise<Map<string, string>> {
      return this.http.get<Map<string, string>>('api/questions-categories')
          .toPromise();
  }

}
